// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:20:33

export default {
  "id": "harvesting-veggies",
  "slug": "harvesting-veggies",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d0fb36f56a7247e79f795deea5e04177-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d0fb36f56a7247e79f795deea5e04177/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Harvesting Veggies",
      "description": "Players will take on the role of a farmer, planting vegetables and achieving a full row or column to harvest. The game is based on a cartoon style, with a fresh and cute overall aesthetic, making it fun and addictive to play.",
      "instructions": "After starting the game, drag the fruit blocks to the empty spaces on the grid. Completing a row or column will eliminate the blocks. Each level ends when the top objectives are completed, unlocking the next level.",
      "genres": [
        "Merge"
      ],
      "tags": [
        "1player",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "收获蔬菜",
      "description": "玩家将扮演一名农民，种植蔬菜，完成一整行或一整列的收获。游戏采用卡通风格，整体风格清新可爱，玩起来既有趣又上瘾。",
      "instructions": "游戏开始后，将水果方块拖动到网格上的空白位置。完成一行或一列将消除方块。每级关卡在完成顶部目标后结束，解锁下一级。",
      "genres": [
        "合并"
      ],
      "tags": [
        "1玩家",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "收穫蔬菜",
      "description": "玩家將扮演農夫的角色，種植蔬菜，並完成一整排或一整列來收穫。遊戲採用卡通風格，整體呈現新鮮可愛的美學，讓遊戲過程既有趣又上癮。",
      "instructions": "遊戲開始後，將水果塊拖動到格子的空白位置。完成一行或一列將消除塊體。每關結束於完成頂部目標時，啟鎖下一關。",
      "genres": [
        "合併"
      ],
      "tags": [
        "1玩家",
        "俄罗斯方塊"
      ]
    },
    "zh-HK": {
      "title": "收穫蔬菜",
      "description": "玩家將扮演一名農夫，種植蔬菜並完成整行或整列以收穫。遊戲採用卡通風格，整體風格新鮮可愛，玩起來既有趣又上癮。",
      "instructions": "遊戲開始後，將果實方塊拖動至格子的空白位置。完成一行或一列將消除方塊。每個等級在完成頂部目標後結束，打開下一個等級。",
      "genres": [
        "合併"
      ],
      "tags": [
        "1人遊戲",
        "俄羅斯方塊"
      ]
    },
    "ja": {
      "title": "野菜収穫",
      "description": "プレイヤーは農家の役割を担い、野菜を植え、一列または一列を完璧に収穫するために達成を目指します。このゲームは、鮮やかで可愛い全体の美学を持つアニメ風のスタイルで、遊ぶのが楽しくて中毒性があります。",
      "instructions": "ゲームを開始後、果物のブロックをグリッドの空きスペースにドラッグしてください。行や列を完成させるとブロックが消えます。各レベルは上層の目標を達成したときに終わり、次のレベルを解除します。",
      "genres": [
        "統合"
      ],
      "tags": [
        "1プレイヤー",
        "テトリス"
      ]
    },
    "ko": {
      "title": "채소 수확",
      "description": "玩家은 농부의 역할을 맡아 채소를 심고 줄이나 행을 채워 수확을 합니다. 게임은 만화 스타일을 기반으로 한 깨끗하고 귀여운 전반적인 아트스타일을 가지고 있어 재미있고 중독성이 있어玩耍에 유리합니다.",
      "instructions": "게임을 시작한 후, 과일 블록을 그리드의 공간으로 끌어서 놓으세요. 행이나 열을 완료하면 블록이 제거됩니다. 각 레벨은 상단 목표를 완료하면 끝나며, 다음 레벨을 해금합니다.",
      "genres": [
        "병합"
      ],
      "tags": [
        "1플레이어",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Récolte de légumes",
      "description": "Les joueurs prendront le rôle d'un agriculteur, planteront des légumes et réalisentront une rangée ou une colonne complète pour récolter. Le jeu se base sur un style cartoon, avec une esthétique fraîche et mignonne, le rendant amusant et accrocheur à jouer.",
      "instructions": "Après avoir démarré le jeu, faites glisser les blocs de fruits dans les espaces vides du grille. Compléter une rangée ou une colonne éliminera les blocs. Chaque niveau se termine lorsque les objectifs supérieurs sont accomplis, déverrouillant ainsi le niveau suivant.",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "1 joueur",
        "Tetris"
      ]
    }
  }
};
